module.exports = __webpack_public_path__ + "static/img/bjrmyy.30c7042.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/bjrmyy.png
// module id = 5Des
// module chunks = 0